import { render } from "./MedicationInfoPage.vue?vue&type=template&id=b097b712&scoped=true"
import script from "./MedicationInfoPage.vue?vue&type=script&lang=js"
export * from "./MedicationInfoPage.vue?vue&type=script&lang=js"

import "./MedicationInfoPage.vue?vue&type=style&index=0&id=b097b712&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b097b712"]])

export default __exports__